import { render, staticRenderFns } from "./LecturePage.vue?vue&type=template&id=38eb5362&scoped=true&"
import script from "./LecturePage.vue?vue&type=script&lang=js&"
export * from "./LecturePage.vue?vue&type=script&lang=js&"
import style0 from "./LecturePage.vue?vue&type=style&index=0&id=38eb5362&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38eb5362",
  null
  
)

export default component.exports